import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { CheckCircleIcon } from 'lucide-react';
export function WhatYouGetSection() {
  const ref = useScrollReveal();
  return <section ref={ref} className="w-full section-padding" style={{
    backgroundColor: '#faf7f2'
  }} aria-label="What you get" data-id="element-267">
      <div className="max-w-3xl mx-auto" data-id="element-268">
        {/* Label */}
        <div className="scroll-reveal text-center mb-10" data-id="element-269">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase px-3 py-1.5 rounded-full" style={{
          color: '#c9a96e',
          backgroundColor: 'rgba(201,169,110,0.12)',
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-270">
            Everything Included
          </span>
        </div>

        {/* Heading */}
        <div className="scroll-reveal scroll-reveal-delay-1 text-center mb-4" data-id="element-271">
          <h2 className="text-3xl md:text-4xl font-bold leading-tight" style={{
          fontFamily: "'Playfair Display', serif",
          color: '#1a2744'
        }} data-id="element-272">
            What You Get Inside the Reset
          </h2>
        </div>

        <div className="scroll-reveal scroll-reveal-delay-2 gold-divider mb-12" data-id="element-273" />

        {/* Items */}
        <div className="space-y-5" data-id="element-274">
          <div className="scroll-reveal scroll-reveal-delay-2 flex gap-4 items-start rounded-xl p-5" style={{
          backgroundColor: '#ffffff',
          border: '1px solid rgba(201,169,110,0.15)',
          boxShadow: '0 2px 12px rgba(26,39,68,0.06)'
        }} data-id="element-275">
            <CheckCircleIcon className="w-6 h-6 flex-shrink-0 mt-0.5" style={{
            color: '#c9a96e'
          }} aria-hidden="true" data-id="element-276" />
            <div data-id="element-277">
              <h3 className="text-base font-semibold mb-1" style={{
              fontFamily: "'Playfair Display', serif",
              color: '#1a2744'
            }} data-id="element-278">
                The 72-Hour Step-by-Step Blueprint
              </h3>
              <p className="text-sm leading-relaxed" style={{
              color: '#6b6560',
              fontFamily: "'Inter', sans-serif"
            }} data-id="element-279">
                A complete, day-by-day protocol to reset the biological clock —
                no guesswork, no interpretation required.
              </p>
            </div>
          </div>

          <div className="scroll-reveal scroll-reveal-delay-3 flex gap-4 items-start rounded-xl p-5" style={{
          backgroundColor: '#ffffff',
          border: '1px solid rgba(201,169,110,0.15)',
          boxShadow: '0 2px 12px rgba(26,39,68,0.06)'
        }} data-id="element-280">
            <CheckCircleIcon className="w-6 h-6 flex-shrink-0 mt-0.5" style={{
            color: '#c9a96e'
          }} aria-hidden="true" data-id="element-281" />
            <div data-id="element-282">
              <h3 className="text-base font-semibold mb-1" style={{
              fontFamily: "'Playfair Display', serif",
              color: '#1a2744'
            }} data-id="element-283">
                The "Invisible String" Bedtime Routine
              </h3>
              <p className="text-sm leading-relaxed" style={{
              color: '#6b6560',
              fontFamily: "'Inter', sans-serif"
            }} data-id="element-284">
                A separation anxiety solution that makes your child feel
                connected to you even after lights out.
              </p>
            </div>
          </div>

          <div className="scroll-reveal scroll-reveal-delay-4 flex gap-4 items-start rounded-xl p-5" style={{
          backgroundColor: '#ffffff',
          border: '1px solid rgba(201,169,110,0.15)',
          boxShadow: '0 2px 12px rgba(26,39,68,0.06)'
        }} data-id="element-285">
            <CheckCircleIcon className="w-6 h-6 flex-shrink-0 mt-0.5" style={{
            color: '#c9a96e'
          }} aria-hidden="true" data-id="element-286" />
            <div data-id="element-287">
              <h3 className="text-base font-semibold mb-1" style={{
              fontFamily: "'Playfair Display', serif",
              color: '#1a2744'
            }} data-id="element-288">
                The "Quiet Return" Technique
              </h3>
              <p className="text-sm leading-relaxed" style={{
              color: '#6b6560',
              fontFamily: "'Inter', sans-serif"
            }} data-id="element-289">
                The exact script and method for handling midnight wanderers —
                present and supportive, but boring and consistent.
              </p>
            </div>
          </div>

          <div className="scroll-reveal scroll-reveal-delay-5 flex gap-4 items-start rounded-xl p-5" style={{
          backgroundColor: '#ffffff',
          border: '1px solid rgba(201,169,110,0.15)',
          boxShadow: '0 2px 12px rgba(26,39,68,0.06)'
        }} data-id="element-290">
            <CheckCircleIcon className="w-6 h-6 flex-shrink-0 mt-0.5" style={{
            color: '#c9a96e'
          }} aria-hidden="true" data-id="element-291" />
            <div data-id="element-292">
              <h3 className="text-base font-semibold mb-1" style={{
              fontFamily: "'Playfair Display', serif",
              color: '#1a2744'
            }} data-id="element-293">
                The Protein Bridge Protocol
              </h3>
              <p className="text-sm leading-relaxed" style={{
              color: '#6b6560',
              fontFamily: "'Inter', sans-serif"
            }} data-id="element-294">
                End 5 AM early-bird wake-ups with a nutritional timing strategy
                that stabilizes overnight sleep chemistry.
              </p>
            </div>
          </div>

          <div className="scroll-reveal scroll-reveal-delay-6 flex gap-4 items-start rounded-xl p-5" style={{
          backgroundColor: '#ffffff',
          border: '1px solid rgba(201,169,110,0.15)',
          boxShadow: '0 2px 12px rgba(26,39,68,0.06)'
        }} data-id="element-295">
            <CheckCircleIcon className="w-6 h-6 flex-shrink-0 mt-0.5" style={{
            color: '#c9a96e'
          }} aria-hidden="true" data-id="element-296" />
            <div data-id="element-297">
              <h3 className="text-base font-semibold mb-1" style={{
              fontFamily: "'Playfair Display', serif",
              color: '#1a2744'
            }} data-id="element-298">
                The Biological Alarm Audit
              </h3>
              <p className="text-sm leading-relaxed" style={{
              color: '#6b6560',
              fontFamily: "'Inter', sans-serif"
            }} data-id="element-299">
                A room-by-room checklist to identify and fix every environmental
                factor sabotaging your child's sleep tonight.
              </p>
            </div>
          </div>

          <div className="scroll-reveal scroll-reveal-delay-6 flex gap-4 items-start rounded-xl p-5" style={{
          backgroundColor: '#ffffff',
          border: '1px solid rgba(201,169,110,0.15)',
          boxShadow: '0 2px 12px rgba(26,39,68,0.06)'
        }} data-id="element-300">
            <CheckCircleIcon className="w-6 h-6 flex-shrink-0 mt-0.5" style={{
            color: '#c9a96e'
          }} aria-hidden="true" data-id="element-301" />
            <div data-id="element-302">
              <h3 className="text-base font-semibold mb-1" style={{
              fontFamily: "'Playfair Display', serif",
              color: '#1a2744'
            }} data-id="element-303">
                3-Night Progress Tracker + Bedroom Safety Checklist
              </h3>
              <p className="text-sm leading-relaxed" style={{
              color: '#6b6560',
              fontFamily: "'Inter', sans-serif"
            }} data-id="element-304">
                Track your progress night by night and ensure your child's sleep
                environment is safe and optimized.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}